<section class="tp-error-area pt-110 pb-110">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-8 col-md-10">
                <div>
                    <div
                        [hidden]="!createProfileState.isWaitingForAPIResponse"
                        class="vb-spinner-box vb-spinner-box--panel">
                        <vb-spinner size="xl" label="Submitting your profile"></vb-spinner>
                    </div>
                    <mat-stepper
                        [hidden]="createProfileState.isWaitingForAPIResponse"
                        [linear]="true"
                        labelPosition="bottom"
                        color="accent"
                        #stepper>
                        <!-- Step 1: Profile Info -->
                        <mat-step
                            state="number"
                            [completed]="isProfileSectionCompleted">
                            <ng-template matStepperIcon="edit">
                                <mat-icon>check_circle</mat-icon>
                            </ng-template>
                            <ng-template matStepLabel>
                                Profile
                                <br />
                                Info
                            </ng-template>
                            <vb-create-user-profile
                                #userProfileSection
                                (selectBusiness)="selectBusiness($event)"
                                (selectCharity)="selectCharity($event)"
                                (submitUserProfileFormData)="
                                    setCreateUserProfileFormData($event)
                                " />
                        </mat-step>
                        <!-- Step 2: Business Info (optional) -->
                        <mat-step
                            state="number"
                            *ngIf="businessSelected"
                            [completed]="isBusinessPreferencesSectionCompleted">
                            <ng-template matStepLabel>
                                Business
                                <br />
                                Info
                            </ng-template>
                            <vb-create-business-profile
                                #businessProfileSection
                                (submitBusinessProfileFormData)="
                                    setCreateBusinessProfileFormData($event)
                                "></vb-create-business-profile>
                        </mat-step>
                        <!-- Step 2: Charity Info (optional) -->
                        <mat-step
                            state="number"
                            *ngIf="charitySelected"
                            [completed]="isCharityPreferencesSectionCompleted">
                            <ng-template matStepLabel>
                                Not For Profit
                                <br />
                                Info
                            </ng-template>
                            <vb-create-charity-profile
                                #charityProfileSection
                                (submitCharityProfileFormData)="
                                    setCreateCharityProfileFormData($event)
                                "></vb-create-charity-profile>
                        </mat-step>
                        <!-- Step 3: Notifications -->
                        <mat-step
                            label="Notifications"
                            state="number"
                            [completed]="
                                isNotificationPreferencesSectionCompleted
                            ">
                            <ng-template matStepperIcon="edit">
                                <mat-icon>check_circle</mat-icon>
                            </ng-template>
                            <ng-template matStepLabel>
                                Notifications
                            </ng-template>
                            <vb-create-notification-preferences
                                #notificationPreferencesSection
                                (notificationPrefSelectedEvent)="
                                    setNotificationPreferences($event)
                                " />
                        </mat-step>
                        <ng-template matStepperIcon="done">
                            <mat-icon>check_circle</mat-icon>
                        </ng-template>
                    </mat-stepper>
                </div>
            </div>
        </div>
    </div>
</section>
